import styled, { keyframes } from "styled-components"
import { overloadColor } from "../../util/style"

const rotateAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

interface SpinnerThrobbingProps {
  size: number
  thickness: number
  colorPrimary: string
  background: string
  duration: number
}
export const SpinnerThrobbing = styled.div<SpinnerThrobbingProps>`
  &::before,
  &::after {
    content: '';
    position: absolute;
    border-radius: 50%;
  }

  position: relative;
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
  position: relative;
  border-radius: 50%;
  color: ${(props) => overloadColor(props.colorPrimary)};
  box-shadow: inset 0 0 0 ${(props) => props.thickness}px;
  transform: translateZ(0);

  &::before {
    width: ${(props) => props.size * 0.6}px;
    height: ${(props) => props.size * 1.1}px;
    background: ${(props) => props.background};
    border-radius: ${(props) => props.size * 1.02}px 0 0
      ${(props) => props.size * 1.02}px;
    top: -${(props) => props.size * 0.03}px;
    left: -${(props) => props.size * 0.05}px;
    transform-origin: ${(props) => props.size * 0.51}px
      ${(props) => props.size * 0.51}px;
    animation: ${rotateAnimation} ${(props) => props.duration}s infinite ease
      ${(props) => props.duration * 0.75}s;
  }
  &::after {
    width: ${(props) => props.size * 0.6}px;
    height: ${(props) => props.size * 1.1}px;
    background: ${(props) => props.background};
    border-radius: 0 ${(props) => props.size * 1.02}px
      ${(props) => props.size * 1.02}px 0;
    top: -${(props) => props.size * 0.05}px;
    left: ${(props) => props.size * 0.49}px;
    transform-origin: ${(props) => props.size * 0.01}px
      ${(props) => props.size * 0.51}px;
    animation: ${rotateAnimation} ${(props) => props.duration}s infinite ease;
  }
`
